import { tns } from "tiny-slider/src/tiny-slider";

const TopicalContentElement = document.getElementById(
  "topical-content__slider"
);

const initTopicalCarousel = () => {
  const slider = tns({
    container: "#topical-content__slider",
    items: 1,
    slideBy: "page",
    autoplay: false,
    controls: false,
    nav: true,
    navPosition: "bottom",
    mouseDrag: true,
    responsive: {
      640: {
        disable: true,
      },
    },
  });
};

if (TopicalContentElement) {
  initTopicalCarousel();
}
